export enum TrackingEventType {
  ADD_TO_CART = 'add_to_cart',
  VIEW = 'view',
  REMOVE_FROM_CART = 'remove_from_cart',
}

export interface BaseTrackingData {
  event_type: TrackingEventType;
  cart_token: string | null;
}

export interface AddToCartTrackingData extends BaseTrackingData {
  event_type: TrackingEventType.ADD_TO_CART;
  line_items: Array<{
    offer_id: number;
    variant_id?: number;
    product_id?: number;
    handle?: string;
    parent_product: {
      id: number;
      handle: string;
    };
    quantity: number;
  }>;
}

export interface ViewTrackingData extends BaseTrackingData {
  event_type: TrackingEventType.VIEW;
  offers?: { id: number; product_ids: number[] }[];
}

export interface RemoveFromCartTrackingData extends BaseTrackingData {
  event_type: TrackingEventType.REMOVE_FROM_CART;
  offer: number;
}

export type TrackingData =
  | AddToCartTrackingData
  | ViewTrackingData
  | RemoveFromCartTrackingData;

export interface TrackingDataOfferAddedToCartPPP extends BaseTrackingData {
  event_type: TrackingEventType.ADD_TO_CART;
  added_via_candyrack_button: boolean;
  line_items: Array<{
    offer_id: string;
    variant_id: string;
    product_id: number;
    handle: string;
    parent_product: {
      id: string;
      handle: string;
    };
    quantity: number;
  }>;
}

export interface TrackingDataOffersViewPPP extends BaseTrackingData {
  event_type: TrackingEventType.VIEW;
  offers: { id: number; product_ids: number[] }[];
}
